import ContentsBase from './ContentsBase';
import LegendGFS from '../legend/LegendGFS';
import { formatBaseTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_GFS } from "../../../store/WeatherContentsState";
import WRAP from 'WRAP-JS';
import TimeController from "../../map/helper/TimeController";
import Gfs from "../../map/layers/Gfs";

class ModelGFS extends ContentsBase {
  static NAME = WX_ID_GFS;
  static GFS_CHANGE_ALL = 'GFS_change_all';
  static GFS_EQV_PT = 'EqvPT';
  static GFS_ISOTACH = 'Isotach';
  static GFS_ISOTHERM = 'Isotherm';
  static GFS_TMINUS_TD = 'TMinusTD';
  static GFS_VWS = 'VWS';
  static GFS_WIND = 'Wind';
  static GFS_ICING_PROB = 'IcingProb';

  static CS_NAME = `CS_${ModelGFS.NAME}`;
  presetId = ModelGFS.CS_NAME;

  prevValidtime;
  contentsVisibleState = {
    EqvPT: true,
    Isotach: true,
    Isotherm: true,
    TMinusTD: true,
    VWS: true,
    Wind: false,
    IcingProb: true
  };
  setRevision;

  constructor(setRevision) {
    super('GFS', 'GFS', 'Model_GFS');
    this.setRevision = setRevision;
    this.timeController = new TimeController(`CS_${WX_ID_GFS}`, {
      crossSection: true,
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg).then(() => {
          if (this.timeController._parent !== null && autoFlg) {
            this.setRevision();
          }
        });
      }
    });
  }

  addObject() {
    return new Promise((resolve, reject) => {
      this.dataHandler = WRAP.DH.addObject(this.dataConfName);
      this.dataHandler.inspect(function (ref) {
        try {
          if (this._validate(ref)) {
            this.dataReference = ref;
            if(this.dataReference.query("timelist").value()) {
              this.parseTimelist();
              this.ready = true;
              this.updated = true;
              resolve();
            }
          } else {
            this.addErrorMessage('Configuration validate error.');
            reject();
          }
        } catch (e) {
          this._error(e);
          reject();
        }
      }.bind(this), false)
    });
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision()
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(date, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(date, fpMode);
        return  {
          Model: {
            Basetime: this.shownTime.basetime,
            Element: {
              ...this.contentsVisibleState
            },
            Name: "GFS",
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ModelGFS.NAME,
      label: 'GFS',
      component: LegendGFS,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ModelGFS.NAME,
      label: 'GFS',
      baseTime: this.shownTime ? formatBaseTime(this.shownTime.basetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }

  getTimeControllerInfo() {
    return {
      mapContentsId: WX_ID_GFS,
      timeController: this.timeController
    };
  }

  setContentsSettings(param) {
    Object.keys(param).forEach(k => {
      this.contentsVisibleState[k] = param[k];
    });
  }

  static resolveCsTargetName(targetName) {
    let csTargetName;
    switch(targetName) {
      case Gfs.WIND_ARROW_NAME:
        csTargetName = ModelGFS.GFS_WIND;
        break;
      case Gfs.ISOTACH_CONTOUR_NAME:
        csTargetName = ModelGFS.GFS_ISOTACH;
        break;
      case Gfs.ISOTHERM_CONTOUR_NAME:
        csTargetName = ModelGFS.GFS_ISOTHERM;
        break;
      case Gfs.ICING_PROB_NAME:
        csTargetName = ModelGFS.GFS_ICING_PROB;
        break;
      default:
        csTargetName = targetName;
        break;
    }
    return csTargetName;
  }
}

export default ModelGFS;
